/**
 * Layout: Vacatureformulier
 * Slug: vacature_formulier
 */

// Opened without a valid vacature: back to the archive
const initVacatureFormulier = () => {
    const layout = document.querySelector(".vacature_formulier-layout[data-redirect-url]");
    if (layout) window.location.replace(layout.dataset.redirectUrl);
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initVacatureFormulier);
} else {
    initVacatureFormulier();
}
